const images = [
  '/solutions/gpo/gpoRosters.png',
  '/solutions/gpo/compare.png',
  '/solutions/gpo/validation.png',
  '/solutions/gpo/reporting.png',
];

export default images;
